import { Controller } from '@hotwired/stimulus';

const listIds = {
    'favorite-panel-programs': 'programFavoriteListContainer',
    'favorite-panel-scholarships': 'scholarshipFavoriteListContainer',
    'favorite-panel-microcerts': 'microCertFavoriteListContainer',
};

export default class extends Controller {
    connect() {
        this.onFavoritesChanged = this.onFavoritesChanged.bind(this);
        document.addEventListener('study:favorites-changed', this.onFavoritesChanged);
    }

    disconnect() {
        document.removeEventListener('study:favorites-changed', this.onFavoritesChanged);
    }

    async onFavoritesChanged(event) {
        const panelId = event.detail?.favoritePanelId;
        const listId = listIds[panelId];
        if (event.detail?.favoriteAction !== 'remove' || !listId) return;

        try {
            const response = await fetch(window.location.href, {
                credentials: 'same-origin',
                headers: { Accept: 'text/html' },
                cache: 'no-store',
            });
            if (!response.ok) return;

            const page = new DOMParser().parseFromString(await response.text(), 'text/html');
            const panel = this.element.querySelector(`#${panelId}`);
            const updatedPanel = page.getElementById(panelId);
            const list = panel?.querySelector(`#${listId}`);
            const updatedList = updatedPanel?.querySelector(`#${listId}`);
            const count = panel?.querySelector('[data-favorite-count]');
            const updatedCount = updatedPanel?.querySelector('[data-favorite-count]');
            if (!list || !updatedList || !count || !updatedCount) return;

            list.innerHTML = updatedList.innerHTML;
            count.textContent = updatedCount.textContent;
            if (!updatedPanel.querySelector('[data-favorite-send]')) {
                panel.querySelector('[data-favorite-send]')?.remove();
            }
        } catch (error) {
            console.warn('Failed to refresh favorites list', error);
        }
    }
}
